import React from "react";
import { Shield, Hammer, Heart } from "lucide-react";
import Reveal from "../shared/Reveal";

const VALUES = [
  {
    icon: Shield,
    title: "Integrity",
    desc: "Fixed-price quotes. No surprise change orders for conditions we should have caught. We own our estimates.",
  },
  {
    icon: Hammer,
    title: "Craftsmanship",
    desc: "We care about what's behind the walls as much as what's in front of them. Every detail is finished the way we'd finish our own home.",
  },
  {
    icon: Heart,
    title: "Respect",
    desc: "Your home is your family's space. We show up on time, clean up daily, and treat it accordingly.",
  },
];

export default function ValuesSection() {
  return (
    <section className="py-20 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left: Dominic */}
          <Reveal y={12}>
            <p className="font-body text-accent text-sm font-semibold uppercase tracking-[0.18em] mb-4">About Dominic</p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground mb-5 leading-tight">
              Built From the Ground Up in Baltimore
            </h2>
            <p className="font-body text-muted-foreground leading-relaxed mb-5 text-base">
              Dominic founded Top-Notch Contractors in 2010 with one goal: deliver the quality of work he'd want on his own home, at a price that's honest and fair. He's personally led more than 500 remodeling projects across Baltimore County since then.
            </p>
            <p className="font-body text-muted-foreground leading-relaxed mb-6 text-base">
              What makes Dominic different is his background. He came up through the trades — framing, tile, finish carpentry — so he understands what a project actually costs, what can go wrong, and how to solve problems creatively in tight old-house layouts. No shortcuts. No hand-offs to subs you've never met.
            </p>
            <div className="flex items-center gap-4 p-5 bg-secondary rounded-xl border border-border">
              <div className="w-12 h-12 bg-accent/15 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="font-heading text-accent font-bold text-lg">D</span>
              </div>
              <div>
                <div className="font-heading font-bold text-foreground">Dominic</div>
                <div className="font-body text-sm text-muted-foreground">Founder & Lead Contractor · Est. 2010</div>
              </div>
            </div>
          </Reveal>

          {/* Right: Values */}
          <div className="space-y-6">
            {VALUES.map((v, i) => (
              <Reveal
                key={v.title}
                delay={i * 100}
                y={12}
                className="flex gap-5 p-6 bg-card rounded-xl border border-border"
              >
                <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <v.icon className="w-6 h-6 text-accent" />
                </div>
                <div>
                  <h3 className="font-heading text-xl font-bold text-foreground mb-2">{v.title}</h3>
                  <p className="font-body text-sm text-muted-foreground leading-relaxed">{v.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}